import React, { useState, ChangeEvent, FocusEvent } from 'react';
import cx from 'classnames';
import styles from './DropdownField.module.scss';
import DownArrowIcon from '../../icons/DownArrowField.svg?icon';

interface DropdownFieldProps {
  children: React.ReactNode;
  defaultValue?: string | number;
  dropdownClass?: string;
  id: string;
  required: boolean;
  onBlur?: (e: FocusEvent<HTMLSelectElement>) => void;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

const DropdownField = ({
  children,
  defaultValue = '',
  dropdownClass = '',
  id,
  required,
  onBlur = () => {},
  onChange,
}: DropdownFieldProps) => {
  const [isDirty, setIsDirty] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setIsDirty(true);
    onChange(e);
  };

  return (
    <select
      className={cx(
        styles.dropdownField,
        dropdownClass,
        isDirty ? styles.dirty : ''
      )}
      defaultValue={defaultValue}
      id={id}
      style={{ backgroundImage: `url(${DownArrowIcon})` }}
      required={required}
      onBlur={onBlur}
      onChange={handleChange}
    >
      {children}
    </select>
  );
};

export default DropdownField;
